<div>
  <!-- redirection component -->
</div>
